<div>
  <!-- redirection component -->
</div>
